<template>
  <div class="wrapper">
    <side-bar v-if="isLoggedIn">
      <template slot="links">
        <sidebar-link to="/dashboard" name="Dashboard" icon="fas fa-business-time"/>
        <sidebar-link to="/calendar" name="Calendar" icon="fas fa-calendar-alt"/>
        <sidebar-link to="/search" name="Search" icon="fas fa-list"/>
        <sidebar-link to="/daily-report" name="Daily Report" icon="fas fa-list"/>
        <sidebar-link to="/employees" name="Employees" icon="fas fa-address-card"/>
        <sidebar-link to="/clients" name="Clients" icon="fas fa-user-friends"/>
        <sidebar-link v-if="isAdmin" to='/users' name="Users" icon="fas fa-user-cog"/>
      </template>
      <mobile-menu>
        <sidebar-link to="/profile" name="Profile" icon="ti-settings"/>
        <li class="nav-item">
          <a class="nav-link" @click="logout">
            <i class="ti-angle-double-left"></i>
            <p>Logout</p>
          </a>
        </li>
        <!--<drop-down class="nav-item"
                   title="5 Notifications"
                   title-classes="nav-link"
                   icon="ti-bell">
          <a class="dropdown-item">Notification 1</a>
          <a class="dropdown-item">Notification 2</a>
          <a class="dropdown-item">Notification 3</a>
          <a class="dropdown-item">Notification 4</a>
          <a class="dropdown-item">Another notification</a>
        </drop-down>-->
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>
    <div class="full-screen" v-if="!isLoggedIn">
        <dashboard-content @click.native="toggleSidebar"></dashboard-content>
    </div>
    <div class="main-panel" v-else>
      <top-navbar ></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer ></content-footer>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import {mapGetters} from "vuex"

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  computed:{
    ...mapGetters([
      'isLoggedIn',
      'isAdmin'
    ])
  },
  methods: {
    logout: function () {
        this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login');
        })
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>
